exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.alert-info[data-v-e43c83b4] {\n\tcolor: #0c5460;\n\tbackground-color: #d1ecf1;\n\tborder-color: #bee5eb;\n}\n", ""]);

// exports
